import { Guest } from "@/types/guest";
import React from "react";

export const SelectGuestData = ({ guest }: { guest: Guest }) => {
  return (
    <div className="flex flex-col">
      <span>
        {guest.profile?.firstName} {guest.profile?.lastName}
      </span>
      {guest.profile?.email && (
        <span className="text-xs text-gray-500">{guest.profile.email}</span>
      )}
    </div>
  );
};
